<style lang="scss">

.catlogodownload {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5rem;

  .catlogo-top {
    width: 80%;
    max-width: 1080px;
    margin-left: 3rem;
    height: 20rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .catlog-top-logo {
      width: 7rem;
      height: 7rem;
      background-image: url("/media/yintai/cat-2.png");
      background-size: 100% 100%;
      border: 1px solid white;
      border-radius: 1rem;
      box-shadow: 1px 1px 2px 2px #cccccc63;
      margin-bottom: 1rem;
    }
    .catlog-top-text {
      font-size: 1.625rem;
      font-family: 'PingFang SC','Microsoft YaHei';
      font-weight: 400;
      color: #212121;
      line-height: 2.625rem;
    }
    .catlog-top-button {
      margin-top: 1rem;
      width: 10rem;
      height: 4rem;
      border: #e8004c 0.1rem solid;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background-color: #e5004f;

      :hover {
        cursor: pointer;
      }
      .catlog-top-button-text {
        font-size: 1.4rem;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 500;
        color: #fff;
      }
    }
  }
}
</style>

<template>
  <div class="catlogodownload">
    <transition name="fade-in-up2">
      <div v-show="this.active_catlogo" class="catlogo-top" ref="catlogo">
        <div class="catlog-top-logo"></div>
        <div class="catlog-top-text">喵街APP在手</div>
        <div class="catlog-top-text">专柜货 上喵街</div>
        <div class="catlog-top-button">
          <a href="https://www.miaostreet.com/clmj/hybrid/universallink"
            ><div class="catlog-top-button-text">立即下载</div></a
          >
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "catlogodownload",
  components: {},
  data() {
    return {
      active_catlogo: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.getDistance); //绑定页面滚动事件
    this.distance_catlogo =
      this.$refs.catlogo.getBoundingClientRect().top - window.innerHeight;
    if (this.distance_catlogo < 0 && this.active_catlogo == false) {
      this.active_catlogo = true;
    }
  },
  methods: {
    getDistance() {
      this.distance_catlogo =
        this.$refs.catlogo.getBoundingClientRect().top - window.innerHeight;

      if (this.distance_catlogo < 0 && this.active_catlogo == false) {
        this.active_catlogo = true;
      }
      if (this.distance_catlogo > 0 && this.active_catlogo == true) {
        this.active_catlogo = false;
      }
    },
  },
};
</script>
